import { getHeaders } from 'auth/auth';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const loanProcessorAPI = createApi({
  reducerPath: 'loanProcessor',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLoanProcessors: builder.query({
      query: ({ pageNumber = 1, pageSize = 20 } = {}) => ({
        url: `/b2b/loan/employee/loan_processor?page_number=${pageNumber}&page_size=${pageSize}`,
        method: 'GET',
        headers: getHeaders(),
      }),
    }),
  }),
});

export const { useGetLoanProcessorsQuery } = loanProcessorAPI;

